import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';

type PaymentStatusChipProps = {
    status: string; // TODO: Use enum for status...
};
const PaymentStatusChip: FC<PaymentStatusChipProps> = ({ status }: PaymentStatusChipProps) => {
    const { t: translate } = useTranslation(['orders']);

    const colorMap: Record<string, string> = {
        UNPAID: 'warning.main',
        PARTIALLY: 'warning.main',
        PAID: 'success.main',
    };

    return <Chip label={translate(status)} sx={{ color: '#fff', backgroundColor: colorMap[status] }} />;
};

export default PaymentStatusChip;
